import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import OrderSearch from './component';

class OrderSearchContainer extends Component {
  constructor() {
    super();
    this.state = {
      search: null,
      resultMessage: '',
      orders: {
        list: [],
        loading: false
      },
      orderDetails: {
        data: null,
        loading: false,
        openModal: false
      }
    };
  }

  onChangeOfOrderSearch = (e, data) => {
    const search = data.value;
    this.setState({ search });
    this.setState({resultMessage: ""})
  };

  onClickOfBrowse = (e) => {
    // console.log("Clicked Browse")
    // http://localhost:3000/
    window.location.assign("https://ticket-support.daalchini.net/")
  }

  onClickOfSearch = (e) => {
    const dataSet = e.target.dataset;
    if (!(dataSet.actiontype === 'onClickOfSearch' || e.keyCode === 13)) {
      return false;
    }
    const value = this.state.search;

    if (!value) {
      return this.setState((prevState, props) => {
        return {
          orders: {
            list: [],
            loading: false
          }
        };
      });
    }
    this.setState((prevState, props) => {
      return {
        orders: {
          list: [],
          loading: true
        }
      };
    });
    this.props.getDataFromAPI(
      `/orders/search?searchWord=${value}`,
      'GET',
      undefined,
      response => {
        this.setState((prevState, props) => {
          const resultMessage = `${response.length} order${response.length>=2?'s':''} found.`;
          return {
            resultMessage,
            orders: {
              list: response,
              loading: false
            }
          };
        });
      },
      err => {
        this.setState((prevState, props) => {
          return {
            orders: {
              list: [],
              loading: false
            }
          };
        });
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  };

  onClickOfViewButton = orderId => {
    this.setState((prevState, props) => {
      return {
        orderDetails: {
          data: null,
          loading: true,
          openModal: true
        }
      };
    });
    this.props.getDataFromAPI(
      `/orders/fulldetails/${orderId}`,
      'GET',
      undefined,
      response => {
        this.setState((prevState, props) => {
          return {
            orderDetails: {
              data: response,
              loading: false,
              openModal: true
            }
          };
        });
      },
      err => {
        this.setState((prevState, props) => {
          return {
            orderDetails: {
              data: null,
              loading: false,
              openModal: false
            }
          };
        });
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  };

  closeModal = () => {
    this.setState((prevState, props) => {
      return {
        orderDetails: {
          data: null,
          loading: false,
          openModal: false
        }
      };
    });
  };

  render() {
    // console.log('orderDetails ----------> ', this.state.orderDetails);
    console.log(this.state);
    
    return (
      <OrderSearch
        orders={this.state.orders}
        resultMessage={this.state.resultMessage}
        orderDetails={this.state.orderDetails}
        onSearchChange={this.onChangeOfOrderSearch}
        onClickOfView={this.onClickOfViewButton}
        closeModal={this.closeModal}
        onClickOfSearch={this.onClickOfSearch}
        onClickOfBrowse={this.onClickOfBrowse}
      />
    );
  }
}

export default connect(null, { getDataFromAPI })(OrderSearchContainer);



// WEBPACK FOOTER //
// ./src/Modules/OrderSearch/container.jsx